import { ref, computed } from '@vue/composition-api';

export function useWarmUpList() {
  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('warmup');

  const warmUpList = ref([]);

  /**
   * Fetch items from API
   * @param {string} token
   * */
  async function fetchWarmUpList(token: string) {
    try {
      const { data } = await instance.list(token);
      warmUpList.value = data;
    } catch (e) {
      throw e;
    }
  }

  return {
    warmUpList,
    fetchWarmUpList,
  };
}
